import React, { useMemo } from 'react';
import { defaultNormalizedVestingsData, useListVestingsQuery } from '../../../../../API/order/vestings/VestingsAPI';
import { getVestingsOptions } from '../../../../../types/order/vestings/IVestingResponse';
import { SelectFieldTW } from '../../../../../tailwindComponents/selectTW/SelectFieldTW';
import { DescriptiveSelectOption } from '../../../../../tailwindComponents/selectTW/interfaces';
import { Tooltip } from '../../../../../ui-toolkit';
import { InformationCircleIcon } from '@heroicons/react/24/outline';

export const VestingReasonSelect: React.FC<{ isVestingDropdownDisabled: boolean }> = ({
  isVestingDropdownDisabled,
}) => {
  const { data: vestingsData = defaultNormalizedVestingsData } = useListVestingsQuery();
  const vestingReasonsOptions = useMemo(() => getVestingsOptions(vestingsData.vestings), [vestingsData.vestings]);

  return (
    <div className={'w-[400px] flex-auto'}>
      <SelectFieldTW
        isNullable
        disabled={isVestingDropdownDisabled}
        name="vestingId"
        options={vestingReasonsOptions}
        placeholder="Select a vesting reason"
        className={'overflow-visible'}
        formatOptionLabel={(option: DescriptiveSelectOption) => {
          return (
            <div className={'flex flex-row items-center justify-between gap-2'}>
              {option.label}
              <Tooltip
                tooltipContent={
                  <div className="max-w-96 overflow-hidden overflow-ellipsis whitespace-normal">
                    {option.description || option.label}
                  </div>
                }
                trigger={'hover'}
                placement={'right'}
              >
                <InformationCircleIcon className={'h-6 w-6'} />
              </Tooltip>
            </div>
          );
        }}
      />
    </div>
  );
};
